export const revisionHistorySelector = state =>
  state.getIn(['app', 'appraisal', 'revisionHistory', 'results']);

export const revisionHistoryInteralSelector = state =>
  state.getIn(['app', 'appraisal', 'revisionHistory', 'resultsInternal']);
